module.exports = __webpack_public_path__ + "static/img/loading_img.93fa3b34.png";